module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('collection', {
    attrs: {
      "loading": _vm.loading,
      "data": _vm.data,
      "structure": _vm.structure,
      "has_searched": _vm.has_searched,
      "params": _vm.params,
      "model": _vm.model
    },
    on: {
      "sorting": _vm.sorting,
      "itemDelete": _vm.itemDelete
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-035b660a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Specific/GeneralListing.vue
// module id = 1794
// module chunks = 0